import '../../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../../../node_modules/lit-element/node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`.mac-ff span{padding-top:3px!important}.win-chrome .primary-button,.win-chrome span,.win-ff .primary-button,.win-ff span{padding-top:6px!important}`;

export { css_248z as default };
